<ng-ebill-header
  *ngIf="(store$ | async) as store"
  [loading]="store.state.loading"
  [profiles]="store.state.profiles"
  [profile]="store.state.selectedProfile!"
  [isAdmin]="store.state.isAdmin!"
  [isValidRacf]="store.state.isValidRacf"
  [impersonateId]="store.state.lookupUserId"
  (selectedProfile)="setSelectedProfile($event)"
  (alternateUser)="setAlternateUser($event)"
  (search)="dispatchSearchBill($event)"
  (validateRacf)="dispatchValidateRacf($event)"
>
</ng-ebill-header>
